const _month_abbr_cache = new Map<string, readonly string[]>();

/**
 * Returns locale-aware month abbreviations using Intl.DateTimeFormat.
 * Index 0 = January, index 11 = December.
 * Result is memoized per locale to avoid constructing a new formatter on every render.
 */
function get_month_abbr(locale: string): readonly string[] {
  const cached = _month_abbr_cache.get(locale);
  if (cached) return cached;
  const formatter = new Intl.DateTimeFormat(locale, { month: 'short' });
  const result = Array.from({ length: 12 }, (_, i) =>
    formatter.format(new Date(2000, i, 1)),
  );
  _month_abbr_cache.set(locale, result);
  return result;
}

/** Format an ISO date string (YYYY-MM-DD) as "D Mon YYYY" (e.g. "31 Mar 2026").
 * Parses parts directly to avoid timezone offset issues. Returns '' on invalid input.
 * Locale defaults to 'en' for English month abbreviations.
 */
export function format_date_xero(iso_date: string, locale = 'en'): string {
  if (!iso_date) return '';
  const parts = iso_date.split('-').map(Number);
  const y = parts[0];
  const m = parts[1];
  const d = parts[2];
  if (!y || !m || !d || m < 1 || m > 12 || d < 1 || d > 31) return '';
  const month_abbr = get_month_abbr(locale)[m - 1];
  return `${String(d)} ${month_abbr} ${String(y)}`;
}
